import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { TimerComponent } from '../timer/timer.component';
import { BidHistoryComponent } from '../bid-history/bid-history.component';

import { MinBidPipe } from '@/pipes/auction-house/min-bid.pipe';
import { WeiPipe } from '@/pipes/auction-house/wei.pipe';

import { AuctionDataService } from '@/services/auction-house/data.service';
import { Web3Service } from '@/services/web3.service';
import { StateService } from '@/services/state.service';
import { ThemeService } from '@/services/theme.service';

import { TippyDirective } from '@/directives/auction-house/tippy.directive';
import { Store } from '@ngrx/store';
import { GlobalState } from '@/models/auction-house/state';

import { selectActiveAuction } from '@/store/auction-house/data.selectors';
import { StarterBidPipe } from '@/pipes/auction-house/starter-bid';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    TimerComponent,
    BidHistoryComponent,

    TippyDirective,

    MinBidPipe,
    WeiPipe,
    StarterBidPipe
  ],
  selector: 'app-bid',
  templateUrl: './bid.component.html',
  styleUrls: ['./bid.component.scss']
})
export class BidComponent {

  bidValue = new FormControl('');

  inputError!: boolean;
  errorMessage!: string | null;
  txHash!: string | undefined;

  activeAuction$ = this.store.select(selectActiveAuction);

  constructor(
    private store: Store<GlobalState>,
    public dataSvc: AuctionDataService,
    public stateSvc: StateService,
    public web3Svc: Web3Service,
    public themeSvc: ThemeService
  ) {}

  async submitBid(tokenId: string): Promise<void> {
    this.closeTransaction();
    this.closeError();

    try {
      await this.web3Svc.checkNetwork();
      // Bid value
      const bidValue: number = Number(this.bidValue.value) || 0;
      if (!bidValue) throw new Error('You must enter a bid value');

      // Get the current active auction
      const currentAuction = await this.web3Svc.getBid(tokenId);
      console.log({ bidValue, currentAuction });

      // Send the tx
      const hash = await this.web3Svc.enterBidForPunk(tokenId, bidValue);
      if (!hash) throw new Error('Transaction failed');
      this.txHash = hash;

      const receipt = await this.web3Svc.waitForTransaction(hash);
      console.log({ receipt });

      this.closeTransaction();
      this.closeError();
      this.resetBid();

    } catch (err: any) {
      this.errorMessage = err.shortMessage || err.message || err;
    }
  }

  setInputError(err: any) {
    this.inputError = true;
    this.errorMessage = err;
  }

  resetBid(): void {
    this.bidValue.reset();
  }

  handleEvent($event: any): void {
    // console.log($event)
    // this.auctionComplete = $event.left > 0 ? false : true;
    // this.auctionClosed = this.currentAuction?.end * 1000 < Date.now();
  }

  closeTransaction() {
    this.txHash = undefined;
  }

  closeError() {
    this.errorMessage = null;
  }
}
